"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OtherReportIcon = OtherReportIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function OtherReportIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#FFEBF5",
    height: "40",
    rx: "20",
    width: "40"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.5625 20.9375C27.0803 20.9375 27.5 20.5178 27.5 20C27.5 19.4822 27.0803 19.0625 26.5625 19.0625C26.0447 19.0625 25.625 19.4822 25.625 20C25.625 20.5178 26.0447 20.9375 26.5625 20.9375Z",
    fill: "#DA3A87",
    stroke: "#DA3A87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 20.9375C20.5178 20.9375 20.9375 20.5178 20.9375 20C20.9375 19.4822 20.5178 19.0625 20 19.0625C19.4822 19.0625 19.0625 19.4822 19.0625 20C19.0625 20.5178 19.4822 20.9375 20 20.9375Z",
    fill: "#DA3A87",
    stroke: "#DA3A87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.4375 20.9375C13.9553 20.9375 14.375 20.5178 14.375 20C14.375 19.4822 13.9553 19.0625 13.4375 19.0625C12.9197 19.0625 12.5 19.4822 12.5 20C12.5 20.5178 12.9197 20.9375 13.4375 20.9375Z",
    fill: "#DA3A87",
    stroke: "#DA3A87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2.5"
  }));
}